// --- Common views
import DownPaymentForm from '@/views/e-commerce-v2/DownPaymentForm.vue';
import TradeInForm from '@/views/e-commerce-v2/TradeInForm.vue';
import TradeInMileageForm from '@/views/shared/TradeInMileageForm.vue';
import TradeInAmountOwingForm from '@/views/shared/TradeInAmountOwingForm.vue';
import TradeInResults from '@/views/shared/TradeInResults.vue';
import CreditIntro from '@/views/shared/CreditIntro.vue';
import AddressForm from '@/views/shared/AddressForm.vue';
import DateOfBirthForm from '@/views/shared/DateOfBirthForm.vue';
import ConfirmCreditForm from '@/views/shared/ConfirmCreditForm.vue';
import VerifyCreditForm from '@/views/shared/VerifyCreditForm.vue';
import PaymentCalculator from '@/views/shared/PaymentCalculator.vue';
import EmptyRouterView from '@/views/shared/EmptyRouterView2.vue';
import ErrorView from '@/views/shared/ErrorPageV2.vue';
import ContactFormWrapper from '@/views/shared/ContactFormWrapper.vue';

// Personalized payment specific
import StepOne from '@/views/e-commerce-v2/personalized-payment/StepOne.vue';
import StepTwo from '@/views/e-commerce-v2/personalized-payment/StepTwo.vue';
import StepThree from '@/views/e-commerce-v2/personalized-payment/StepThree.vue';

// Sub routes
import OfferSubRoute from '@/router/mobile/e-commerce-v2/sub-routes/offer';
import TradeInSubRoute from '@/router/mobile/shared/trade-in';
import FinanceSubRoute from '@/router/mobile/shared/finance';

// Credit sub flow - only results page and can select range if credit checks failed
import SelectCreditRange from '@/views/shared/credit/SelectCreditRange.vue';
import CreditResults from '@/views/shared/credit/CreditResults.vue';
import CarfaxBasicForm from '@/components/shared/trade-in-carfax/CarfaxBasicForm.vue';
import CarfaxDetailsForm from '@/components/shared/trade-in-carfax/CarfaxDetailsForm.vue';

export default [
  {
    path: '',
    redirect: { path: 'step-one' },
  },
  {
    path: 'step-one',
    component: StepOne,
    meta: {
      headerIcon: 'back',
      hasNext: true,
      nextRoutePath: 'down-payment-form',
    },
  },
  {
    path: 'down-payment-form',
    component: DownPaymentForm,
    meta: {
      headerIcon: 'back',
      navInfo: {
        from: 0,
        to: 1,
      },
      numberOfSteps: 9,
      hasNext: true,
      nextRoutePath: 'trade-in-form',
    },
  },
  {
    path: 'trade-in-form',
    component: TradeInForm,
    meta: {
      headerIcon: 'back',
      navInfo: {
        from: 1,
        to: 2,
      },
      numberOfSteps: 9,
      hasNext: true,
    },
  },
  {
    path: 'carfax-basic-form',
    component: CarfaxBasicForm,
    meta: {
      headerIcon: 'back',
      navInfo: {
        from: 2,
        to: 3,
      },
      numberOfSteps: 9,
      hasNext: true,
      nextRoutePath: 'carfax-details-form',
    },
  },
  {
    path: 'carfax-details-form',
    component: CarfaxDetailsForm,
    meta: {
      headerIcon: 'back',
      navInfo: {
        from: 3,
        to: 4,
      },
      numberOfSteps: 9,
      hasNext: true,
      nextRoutePath: 'trade-in-mileage',
    },
  },
  {
    path: 'trade-in-mileage',
    component: TradeInMileageForm,
    meta: {
      headerIcon: 'back',
      navInfo: {
        from: 4,
        to: 5,
      },
      numberOfSteps: 9,
      hasNext: true,
      nextRoutePath: 'trade-in-amount-owing-form',
    },
  },
  {
    path: 'trade-in-amount-owing-form',
    component: TradeInAmountOwingForm,
    meta: {
      headerIcon: 'back',
      navInfo: {
        from: 5,
        to: 6,
      },
      numberOfSteps: 9,
      hasNext: true,
      nextRoutePath: 'contact-info-form',
    },
  },
  {
    path: 'contact-info-form',
    component: ContactFormWrapper,
    meta: {
      navInfo: {
        from: 6,
        to: 7,
      },
      numberOfSteps: 9,
      headerIcon: 'back',
      hasNext: true,
    },
  },
  {
    path: 'trade-in-results',
    component: TradeInResults,
    meta: {
      headerIcon: false,
      navInfo: {
        from: 7,
        to: 8,
      },
      numberOfSteps: 9,
      hasNext: true,
      nextRoutePath: 'step-two',
      v2FooterStyleClasses: 'grey',
    },
  },
  {
    path: 'trade-in-error',
    component: ErrorView,
    meta: {
      headerIcon: false,
      navInfo: false,
      hasNext: true,
      nextRoutePath: 'step-two',
      errorPayload: {
        errorType: 'trade',
        errorMsg: 'personalized',
        buttonText: 'continueWithoutTrade',
      },
    },
  },
  {
    path: 'step-two',
    component: StepTwo,
    meta: {
      headerIcon: false,
      hasNext: true,
      nextRoutePath: 'credit-intro',
    },
  },
  {
    path: 'credit-intro',
    component: CreditIntro,
    meta: {
      headerIcon: 'back',
      navInfo: {
        from: 0,
        to: 1,
      },
      numberOfSteps: 5,
      hasNext: true,
      nextRoutePath: 'address-form',
    },
  },
  {
    path: 'address-form',
    component: AddressForm,
    meta: {
      headerIcon: 'back',
      navInfo: {
        from: 1,
        to: 2,
      },
      numberOfSteps: 5,
      hasNext: true,
      nextRoutePath: 'date-of-birth-form',
    },
  },
  {
    path: 'date-of-birth-form',
    component: DateOfBirthForm,
    meta: {
      headerIcon: 'back',
      navInfo: {
        from: 2,
        to: 3,
      },
      numberOfSteps: 5,
      hasNext: true,
      nextRoutePath: 'confirm-credit-form',
    },
  },
  {
    path: 'confirm-credit-form',
    component: ConfirmCreditForm,
    meta: {
      headerIcon: 'back',
      navInfo: {
        from: 3,
        to: 4,
      },
      numberOfSteps: 5,
      hasNext: true,
      nextRoutePath: 'step-three',
    },
  },
  {
    path: 'step-three',
    component: StepThree,
    meta: {
      headerIcon: false,
      hasNext: true,
    },
  },
  {
    path: 'verify-credit-form',
    component: VerifyCreditForm,
    meta: {
      headerIcon: false,
      navInfo: {
        from: 0,
        to: 1,
      },
      numberOfSteps: 2,
      hasNext: true,
      nextRoutePath: 'payment-calculator',
    },
  },
  {
    path: 'payment-calculator',
    component: PaymentCalculator,
    meta: {
      headerIcon: false,
      headerStyleClasses: 'mb-0',
      updateLeadOnEnter: false,
    },
  },
  {
    path: 'offer',
    component: EmptyRouterView,
    children: OfferSubRoute,
    redirect: { path: 'offer/offer-summary-form' },
  },
  {
    path: 'trade-in',
    component: EmptyRouterView,
    children: TradeInSubRoute,
    redirect: { path: 'trade-in/carfax-basic-form' },
  },
  {
    path: 'finance',
    component: EmptyRouterView,
    children: FinanceSubRoute,
    redirect: { path: 'finance/finance-intro' },
  },
  {
    path: 'credit/select-credit-range',
    component: SelectCreditRange,
    meta: {
      headerIcon: 'back',
      hasNext: false,
    },
  },
  {
    path: 'credit/credit-results',
    component: CreditResults,
    meta: {
      headerIcon: false,
      navInfo: false,
      hasNext: true,
    },
  },
  {
    path: 'credit-error',
    component: ErrorView,
    meta: {
      headerIcon: false,
      navInfo: false,
      hasNext: true,
      nextRoutePath: 'payment-calculator',
      errorPayload: {
        errorType: 'credit',
        errorMsg: 'default',
        buttonText: 'continuePayment',
      },
    },
  },
];
